import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";
import { applyTelegramChrome, lockVerticalSwipes } from "./lib/tg";

// Сообщаем Telegram, что Mini App готово к отображению (убирает лоадер).
window.Telegram?.WebApp?.ready();
// Разворачиваем Mini App на весь экран.
window.Telegram?.WebApp?.expand();
// Шапка и фон клиента — нашей палитрой (дальше их обновляет смена темы).
// Вызываем здесь, а не в модуле темы: до импорта styles.css CSS-переменных
// ещё нет, и читать из них цвет нечего.
applyTelegramChrome();
// Свайп вниз по контенту больше не закрывает приложение: он нужен каталогу
// (pull-to-refresh) и карточке товара (листание фото).
lockVerticalSwipes();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
